import angular from 'angular';
import { FileDragService } from './FileDragService';
import 'components/sharpr/identity/identityModule';
import 'components/sharpr/api/apiModule';
import 'components/sharpr/theme/themeModule';
import 'components/sharpr/cfg/cfgModule';

angular.module('sh.fileDrag', ['sh.identity', 'sh.api', 'sh.theme', 'sh.cfg']).service('FileDrag', FileDragService);
